import React from 'react';
import lodash from 'lodash';
import styles from 'pages/studyOverview/containers/StudyOverview/WidgetCount.scss';
import { SpinnerMini } from 'components/common/LoadingStatus/LoadingStatus';
import classnames from 'classnames';

function WidgetCount(props) {
    const count = lodash.isNull(props.count) ? '-' : props.count;
    return (
        <div className={classnames(styles.widgetCount, { [styles.errorCount]: props.count > 0})} data-cy="WidgetCount">
            {!!props.label &&
                <h2 className={styles.label} data-cy="WidgetCount-h2">{props.label}</h2>
            }
            {props.isLoadingExpectedDocuments ? 
                <div className={styles.spinner}>
                    <SpinnerMini className={styles.filled}/>
                </div> 
                : 
                <h3 data-cy="WidgetCount-count">{count}</h3>}
        </div>

    );
}

export default WidgetCount;
